import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import { TableBody, TableRow, TableCell } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import SMJItemMenu from './SMJItemMenu';

import columnsConfig from './columnsConfig';

function SMJListTableRows({ smjList, options, actions, smjModelById, columnNames }) {
  const theme = useTheme();
  return (
    <TransitionGroup component={TableBody}>
      {smjList.map(smj => (
        <CSSTransition timeout={300} classNames="fade" key={smj.id || uuid()}>
          <TableRow
            key={smj.id || uuid()}
            hover
            onDoubleClick={e => {
              e.preventDefault();
              actions.edit(smj);
            }}
          >
            <TableCell>
              <SMJItemMenu
                smj={smj}
                options={options}
                actions={{
                  edit: () => actions.edit(smj),
                  delete: () => actions.delete(smj),
                }}
              />
            </TableCell>
            {columnNames.map(columnName => (
              <TableCell
                style={{ padding: '4px', color: theme.palette.text.secondary }}
                key={columnName}
              >
                {columnsConfig.renderCell(columnName, smj, { smjModelById })}
              </TableCell>
            ))}
          </TableRow>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
}

SMJListTableRows.propTypes = {
  smjList: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  smjModelById: PropTypes.object.isRequired,
  columnNames: PropTypes.array.isRequired,
};

export default SMJListTableRows;
